import { Reveal, Eyebrow } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1611937187627-a427e75ecf65?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1400";

export const About = () => (
  <section id="about" data-testid="about-section" className="py-24 md:py-36">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 md:px-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <img src={ABOUT_IMG} alt="Leather-trimmed steering wheel of a luxury car" data-testid="about-image" className="aspect-[3/4] w-full object-cover" />
      </Reveal>
      <div className="lg:col-span-6 lg:col-start-7">
        <Reveal>
          <Eyebrow>About S &amp; H</Eyebrow>
          <h2 className="mt-6 font-display text-4xl font-light leading-tight tracking-tight md:text-5xl">
            Buying a luxury car should feel like a luxury.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 space-y-6 text-base leading-relaxed text-stone md:text-lg">
            <p>
              For most people, buying a high-end car means weeks of searching listings, chasing dealers, going back and forth on
              price and sorting through documents. S &amp; H | Automotive Acquisition Group exists to take all of that off your plate.
            </p>
            <p>
              We act as your private buyer. You tell us what you are looking for — and what you will not accept — and we take over
              the entire process: sourcing, negotiating, preparing the paperwork and organizing shipping. When everything is ready,
              you receive a complete deal package to sign, pay and take delivery.
            </p>
            <p>
              Our focus is your time and your peace of mind. Because every deal is negotiated by someone who does it well, you may
              also end up paying less than you would on your own — a happy side effect, not the point.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-12 grid grid-cols-2 gap-8 border-t border-hairline pt-8">
            <div data-testid="about-service-area">
              <p className="text-[11px] uppercase tracking-[0.28em] text-mist">Based in</p>
              <p className="mt-2 font-display text-2xl">Toronto</p>
            </div>
            <div>
              <p className="text-[11px] uppercase tracking-[0.28em] text-mist">Serving</p>
              <p className="mt-2 font-display text-2xl">Across Canada</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
